import React from 'react';

import { TableCell, TableHead, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { StyledTableCell } from './index.styles';

const TemplatesTableHeader: React.FC = () => {
    const { t } = useTranslation('templates');

    return (
        <TableHead>
            <TableRow>
                <StyledTableCell>{t('title')}</StyledTableCell>
                <TableCell>{t('actions')}</TableCell>
            </TableRow>
        </TableHead>
    );
};

export default TemplatesTableHeader;
